export default __webpack_public_path__ + "static/media/youtube-live-btn.2b651692.png";